module.exports = __webpack_public_path__ + "img/cartaz-mobile.4287630f.jpg";